/* eslint-disable react/jsx-props-no-spreading */
import React, { ComponentProps } from 'react';
import { Link } from 'react-router-dom';
import { createAppPathAndPersistQuery, LAUNCH, LOGIN } from '../../utils/router';
import '../../web-shared/common/links.sass';
import { createLinkComponent } from '../../web-shared/general/base-button-link';

/** KU
 *
 * Wrapped version of a react-router-dom Link that persists the current query
 */
export const Anchor = ({
  href,
  children,
  replace,
  ...props
}: Omit<ComponentProps<typeof Link>, 'to'> & {
  href: string;
}) => {
  // KU – handle external links
  if (![LOGIN, LAUNCH].some(it => href?.startsWith(it))) {
    return (
      <a {...props} href={href} suppressHydrationWarning>
        {children}
      </a>
    );
  }

  return (
    <Link
      {...props}
      to={createAppPathAndPersistQuery(href)}
      replace={replace}
      suppressHydrationWarning
    >
      {children}
    </Link>
  );
};

/** KU
 *
 * Wrapped version of an Anchor that uses our custom styling
 */
export const StyledAnchor = createLinkComponent(Anchor);
